import * as exUtils from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        showToast(config?: Record<string, any>): HTMLElement;
        hideToast(config?: Record<string, any>): HTMLElement;
        disposeToast(config?: Record<string, any>): HTMLElement;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.showToast = function (config?: Record<string, any>): HTMLElement {
    exUtils.show(this, config);

    return this;
};

HTMLElement.prototype.hideToast = function (config?: Record<string, any>): HTMLElement {
    exUtils.hide(this, config);

    return this;
};

HTMLElement.prototype.disposeToast = function (config?: Record<string, any>): HTMLElement {
    exUtils.dispose(this, config);

    return this;
};
